export interface ICompany {
    id: number,
    company: string;
    address: string;
    country: string;
    state: string;
    city: string;
    code: string;
    zipCode: number;
    logo: string;
    stamp: string;
    status: boolean;
    directors?: any[];
    auditors?: any[];
    pfConsultants?: any[];
    ll: number 
}

export interface Document {
    id: number;
    document_Name: string;
    description: string;
    can_Accept_Duplicate: boolean;
    branch_Wise: boolean;
    isMapped: boolean;
}

export interface Category {
    category_Id: number;
    category_Name: string;
    isAllSelected: boolean;
    documents: Document[];
}

export const sortOptions: string[] = [
  "Company Name (A-Z)",
  "Company Name (Z-A)",
];

export const sortMapping: Record<string, { field: string; order: 1 | -1 }> = {
  "Company Name (A-Z)": { field: "company", order: 1 },
  "Company Name (Z-A)": { field: "company", order: -1 },
};